module.exports = __webpack_public_path__ + "img/Ferimentos e aberturas naturais macieira - Queda de Petálas 1.10403f3b.webp";